import { useCallback, useEffect, useState } from 'react'
import usersStore from '../../../store/users'
import stageStore from '../../../store/stage'
import Input from '../../ui/input/input'
import Button from '../../ui/button/button'
import Modal from '../../modal/modal'
import { emmiter } from '../../../helpers/Emmiter'
import { getDeclination } from '../../../helpers/common'
import DropdownHOC from '../../dropdownHOC/dropdownHOC'
import usePosition from '../../../hooks/position.hook'
import { SubuserItem } from './SubuserItem'
import { getSubUsersGroup } from '../../../utils/subUsersGroup'
import { useNotification } from '../../../hooks/notification.hook'
import dashbordStore from '../../../store/dashbord'
import { getDrawingTime } from '../../../utils/getDrawingTime'
import { observer } from 'mobx-react-lite'

function StampProgressModal() {
  const notification = useNotification()
  const [initialValue, setInitialValue] = useState(0)
  const [seed, setSeed] = useState(1)
  const [modal, setModal] = useState(false)
  const [quantity, setQuantity] = useState(null)
  const [user, setUser] = useState(null)
  const { username, id: userId } = user || {}
  const { drawings = [], drawingId } = modal
  const [subusers, setSubusers] = useState([])
  const [drawingTime, setDrawingTime] = useState(null)
  const {printsList} = dashbordStore

  const candidates = usersStore.users
    .filter(x => x.m_roles.find(y => y.name === "Печатник"))
    .map(x => ({ title: x.username, onEvent: () => onSetUser(x) }))
  const total = subusers.reduce((acc, curr) => {
    return (acc += curr.totalReadyCount)
  }, 0)

  const remain = modal.quantity - total < 0 ? 0 : modal.quantity - total
  const { totalReadyCount: currentUserCount = 0 } = subusers.find(x => x.user.id === user?.id) || {}
  const maxValue = remain + currentUserCount
  const { setPrintQuantity } = usePosition()

  useEffect(() => {
    if(!modal) return;
    const drawingTime = getDrawingTime(modal.code, remain, printsList)
    setDrawingTime(drawingTime)
  }, [remain, total, modal])

  useEffect(() => {
    emmiter.on('stampProgressModal', data => {
      setModal(data)
    })
    return () => emmiter.off('stampProgressModal')
  }, [])

  const onSetQuantity = value => {
    if (+value <= maxValue) {
      setQuantity(value)
    } else {
      setQuantity(maxValue)
    }
  }

  const onSetUser = user => {
    setUser(user)
  }

  const prepareAndSetSubusers = useCallback((subusers) => {
    const groupSubUsers = getSubUsersGroup(subusers)
    setSubusers(Object.values(groupSubUsers))
  }, [setSubusers])

  const onSubmit = async () => {
    const { drawingId, positionStageId, getData } = modal
    const { subusers: updated } = await setPrintQuantity({
      positionStageId,
      userId,
      subusers,
      quantity,
      drawingId
    })
    setSeed(Math.random())
    prepareAndSetSubusers(updated)
    setUser(null)
    setQuantity(null)
    getData(true)
    setInitialValue(0)
    notification('Прогресс печати обновлен')
  }

  const setInitData = (subusers = []) => {
    prepareAndSetSubusers(subusers)
  }

  useEffect(() => {
    const drawingSubusers = drawings.find(x => x.id === drawingId)?.subusers || []
    setInitData(drawingSubusers)
  }, [modal, prepareAndSetSubusers])

  useEffect(() => {
    if (user && quantity) {
      if (quantity > maxValue) {
        setInitialValue(maxValue)
      }
    }
  }, [maxValue, quantity, user])

  const subUsersItemsRender = subusers.map((subuser) => {
    return (
      <SubuserItem key={subuser.user.id}
                   data={subuser}
                   maxValue={maxValue}
                   setInitData={setInitData}
                   modal={modal}

      />
    )
  })


  return (
    <Modal isOpen={modal} closeModal={() => setModal(false)}>
      <div className='w-[90vw] max-w-[76rem] min-h-[10rem] pt-[7rem]'>
        <span className='block text-center text-Regular(48_52) text-Content/Dark mb-[2rem]'>Прогресс печати</span>
        <div className='text-Regular(14_16) text-center text-Content/Middle'>{modal.name}</div>
        <div className='text-Regular(16_20) text-center mt-[0.5rem]'>
          {`${total || 0} ${getDeclination(total, ['штук', 'штуки', 'штук'])} (осталось ${remain})`}
        </div>
        {drawingTime && <div>
          {drawingTime.timeForDrawingComplete && <div className='text-Regular(16_20) text-center mt-[0.5rem]'>
            <span>Время для печати оставшегося кол-ва:</span>
            <span className={`font-bold ml-[1rem]`}>{drawingTime.timeForDrawingComplete}</span>
          </div>
          }
          {(!modal.union_hash || modal.union_hash_index === 1) && !total && drawingTime.prepareProcessTime && <div className='text-Regular(16_20) text-center mt-[0.5rem]'>
            <span>Время настройки:</span>
            <span className={`font-bold ml-[1rem]`}>
            {`${drawingTime.prepareProcessTime} мин`}
          </span>
          </div>}
        </div>
        }
        <div className='p-[3rem]'>
          <div className='py-[5rem] px-[4rem] bg-Dominant/Dop '>
            <span className='text-Regular(16_18)'>
              {modal.title} - <span
              className='font-medium'>{modal.code}</span>{' '}
            </span>
            <div className='flex flex-col mt-10'>
              <div className='text-Regular(16_18) font-medium'>Исполнители:
              </div>
              <div className='flex flex-col gap-[8px] mt-[8px]'>
                {subUsersItemsRender}
              </div>
            </div>

            <div className='mt-[3.8rem]'>
              <div className='grid grid-cols-2'>
                <Input
                  key={seed}
                  type='number'
                  onInput={({ target: { value } }) => onSetQuantity(value)}
                  maxValue={maxValue}
                  placeholder='Введите число'
                  initial={initialValue || ''}
                  // label="Сколько вы уже распечатали?"
                ></Input>
                <DropdownHOC
                  items={candidates.sort((a, b) => a.title.localeCompare(b.title, 'ru'))}
                  title={username || 'Выберите исполнителя'}
                  className='flex items-center h-[100%] bg-white'></DropdownHOC>
              </div>
            </div>

            <div className='flex justify-center mt-[3.8rem]'>
              <Button disabled={!(user && quantity)} name='Сохранить'
                      onPress={onSubmit}></Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default observer(StampProgressModal)
